import {dashboardPageRoute} from './DashboardPage';
import {priceQuotesPageRoute} from './PriceQuotesPage';
import {ordersPageRoute} from './OrdersPage';
import {orderDetailsRoute} from './OrderDetails';
import {inspectionsPageRoute} from './InspectionsPage';
import {inspectionDetailsPageRoute} from './InspectionDetails';
import {customersEntityRoute} from './CustomersEntity';
import {customerDetailsRoute} from './CustomerDetails';
import {oldInspectionsPageRoute} from './OldInspectionsPage';
import {oldInspectionDetailsRoute} from './OldInspectionDetails';
import {tasksRoute} from './TasksPage';
import {usersActionsRoute} from './UsersActions';
import {contactsRoute} from './ContactsPage';
import {priceQuoteDetailsRoute} from './PriceQuoteDetails';
import {inspectionsMapPageRoute} from './InspectionsMap';
import {priceCatalogRoute} from './PriceCatalogPage';
import {notificationsRoute} from './NotificationsPage';

export default [
  dashboardPageRoute,
  priceQuotesPageRoute,
  ordersPageRoute,
  orderDetailsRoute,
  inspectionsPageRoute,
  inspectionDetailsPageRoute,
  customersEntityRoute,
  customerDetailsRoute,
  oldInspectionsPageRoute,
  oldInspectionDetailsRoute,
  tasksRoute,
  usersActionsRoute,
  contactsRoute,
  priceQuoteDetailsRoute,
  inspectionsMapPageRoute,
  priceCatalogRoute,
  notificationsRoute
];
